<template>
  <section class="kws-quiz-poll-result" v-bind="parseAttributeString">
    <div class="kws-quiz-text-wrapper">
      <h2 class="h2">{{ headline }}</h2>
      <first-spirit-image
        v-if="img && img.sm"
        class="kws-quiz-img-mobile"
        :fs-cc-attrs="img.fsCcAttrs"
        :alt="img.alt"
        :src="img.sm.src"
        :srcset="img.sm.srcset"
        :sizes="img.sm.sizes"
      ></first-spirit-image>
      <div class="kws-quiz-text-content">
        <p class="">{{ text }}</p>

        <div
          class="kws-quiz-poll-result-question"
          v-for="(question) in pollResult" :key="question.pollId"
        >
          <div class="kws-quiz-poll-result-answer"
               v-for="(answer) in question.pollAnswers"
               :key="answer.answerId"
          >
            <h3>{{ answer.title }}</h3>
            <meter-bar :value="answer.average | round(1)"></meter-bar>
          </div>
        </div>
      </div>
    </div>
    <div class="kws-quiz-img-desktop">
      <first-spirit-image
        v-if="img && img.lg"
        class="kws-quiz-img-desktop"
        :fs-cc-attrs="img.fsCcAttrs"
        :alt="img.alt"
        :src="img.lg.src"
        :srcset="img.lg.srcset"
        :sizes="img.lg.sizes"
      ></first-spirit-image>
    </div>
  </section>
</template>

<script>
import MeterBar from './meter-bar.vue';
import FirstSpiritContentCreatorMixin from '../../shared/mixins/FirstSpiritContentCreatorMixin';
import FirstSpiritImage from './fs-image.vue';

export default {
  props: {
    headline: String,
    text: String,
    img: Object,
    pollResult: Array,
  },
  mixins: [FirstSpiritContentCreatorMixin],
  components: {
    MeterBar,
    FirstSpiritImage,
  },
};
</script>

<style scoped lang="scss">
.kws-quiz-poll-result {
  background-color: rgba(255, 255, 255, .75);
  color: $color-black;

  h3 {
    font-size: rem(15px);
    line-height: rem(18px);
    margin-bottom: rem(10px);
  }
}

.kws-quiz-poll-result-answer {
  margin-bottom: rem(20px);
}
</style>
